import { getCookie } from '@utils/cookies';

export const mutator = (args: any) => {
	const workspaceCode = getCookie('workspace_code');

	const options = {
		staleTime: 60 * 1000,
		cacheTime: 3 * 60 * 1000,
	};

	const queryKey = args.queryKey.includes(workspaceCode)
		? args.queryKey
		: [...args.queryKey, workspaceCode];

	return { ...options, ...args, queryKey };
};

export default mutator;
